package pt.at.oss.kotlin.core.enumeration

/**
 * Created by Pedro Alfaiate on 02/11/2021.
 */

class MemberStateUeToA2Adapter(ms: MemberState) : WithCodeA2 {
    override val codeA2 = ms.ueCode
}

val MS_A2 = MemberState.values().map { MemberStateUeToA2Adapter(it) }
val MS_A2_EXCEPT_PT = MS_A2.filter { it.codeA2 != MemberState.PORTUGAL.ueCode }
